import { render, staticRenderFns } from "./kycView.vue?vue&type=template&id=e47223b6&scoped=true&"
import script from "./kycView.vue?vue&type=script&lang=js&"
export * from "./kycView.vue?vue&type=script&lang=js&"
import style0 from "./kycView.vue?vue&type=style&index=0&id=e47223b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47223b6",
  null
  
)

export default component.exports